import { gql } from 'react-apollo';
import { full } from "../../../../graphql/fragments/faqAnswer";

export const updateFaqAnswer = gql`
  mutation updateFaqAnswer($input: UpdateFaqAnswerInput!) {
    updateFaqAnswer(input: $input) {
      faqAnswer: faq_answer {
        ...allFaqAnswersFields
      }
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/faqAnswers/mutations/updateFaqAnswer.js